import { PropsWithChildren } from "react";
import './tableAction.scss';

export function TableActions({ children }: PropsWithChildren<{}>) {
    return <div className="kedle-table-actions" >
        {children}
    </div >;
}
